export default __webpack_public_path__ + "971fe2dd6844e28cc86a5ccac49a07f9.jpg";